import { Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { Transporter } from '../models/transporter.model';
import { createRequestOption, mapAsBody } from '../app/shared/util/request-util';
import { isPresent } from './operators';
import { ApplicationConfigService } from './application-config.service';
import { API_ENDPOINTS } from '../models/enums/endpoints.enum';
import { IBaryTableFetchService } from './i-bary-table-fetch-service';
import { ApiProviderService } from './api-provider.service';
import { TransportOrderView } from '../models/transport-order-view.model';

export type EntityResponseType = HttpResponse<Transporter>;
export type EntityArrayResponseType = HttpResponse<Transporter[]>;

@Injectable({ providedIn: 'root' })
export class TransporterService implements IBaryTableFetchService<Transporter> {
  protected resourceUrl: string;

  constructor(protected apiProvider: ApiProviderService, protected applicationConfigService: ApplicationConfigService) {
    this.resourceUrl = API_ENDPOINTS.TRANSPORTER;
  }

  public create(transporter: Transporter): Observable<EntityResponseType> {
    return this.apiProvider.post<Transporter>(this.resourceUrl, transporter);
  }

  public update(transporter: Transporter): Observable<EntityResponseType> {
    return this.apiProvider.put<Transporter>(`${this.resourceUrl}/${transporter.id}`, transporter);
  }

  partialUpdate(transporter: Transporter): Observable<EntityResponseType> {
    return this.apiProvider.patch<Transporter>(this.resourceUrl, transporter);
  }

  find(id: number): Observable<EntityResponseType> {
    return this.apiProvider.get<Transporter>(`${this.resourceUrl}/${id}`, { observe: 'response' });
  }

  public getByCustomerId(): Observable<Transporter> {
    return this.apiProvider.get<Transporter>(`${this.resourceUrl}`, { observe: 'response' }).pipe(mapAsBody);
  }

  query(req?: any): Observable<EntityArrayResponseType> {
    const options = createRequestOption(req);
    return this.apiProvider.get<Transporter[]>(this.resourceUrl, { params: options, observe: 'response' });
  }

  delete(id: number): Observable<HttpResponse<{}>> {
    return this.apiProvider.delete(`${this.resourceUrl}/${id}`);
  }

  addTransporterToCollectionIfMissing(transporterCollection: Transporter[], ...transportersToCheck: (Transporter | null | undefined)[]): Transporter[] {
    const transporters: Transporter[] = transportersToCheck.filter(isPresent);
    if (transporters.length > 0) {
      const transporterCollectionIdentifiers = transporterCollection.map(transporter => transporter.id);
      const transportersToAdd = transporters.filter(transporter => {
        const transporterIdentifier = transporter.id;
        if (transporterIdentifier == null || transporterCollectionIdentifiers.includes(transporterIdentifier)) {
          return false;
        }
        transporterCollectionIdentifiers.push(transporterIdentifier);
        return true;
      });
      return [...transportersToAdd, ...transporterCollection] as TransportOrderView[];
    }
    return transporterCollection;
  }

  fillDataToShow(entities: Transporter[]): Observable<Transporter[]> {
    return of(entities);
  }

  updateOrder(entities: Transporter[]): Observable<Transporter[]> {
    return of(entities);
  }
}
